import { IImageProps } from "@/lib/types/components.js";
import * as S from "./styles.ts";
import { IButtonProps } from "@/template/components/Button/index.tsx";
import StepCard from "./component/StepCard.tsx";

export interface IStepCard {
  title: string;
  description: string;
  link: {
    label: string;
    href: string;
    isButton?: boolean;
  };
  image: IImageProps;
  showImageOnTop?: boolean;
}

interface IStepComponentProps {
  headingTag?: "h1" | "h2" | "h3";
  heading: string;
  description: string;
  stepCard: IStepCard[];
  enableCustomBlock?: boolean;
  content?: string;
  isContentHeading?: boolean;
  button?: ({
    label: string;
    link: string;
    variant: "outline" | "flat" | "solid" | "light";
    target?: "_blank";
    icon?: string;
    hasEffect?: boolean;
  } & Partial<IButtonProps>)[];
  altStyling?: boolean;
  isFourColumnLayout?: boolean;
}

const StepsComponent = ({
  headingTag = "h1",
  heading,
  description,
  stepCard,
  enableCustomBlock,
  content,
  button,
  altStyling,
  isContentHeading,
  isFourColumnLayout,
}: IStepComponentProps) => {
  return (
    <>
      <S.StepContainer
        $altStyling={altStyling}
        id="step-card-section"
      >
        <S.StepHeader>
          <S.Title as={headingTag}>{heading}</S.Title>
          <S.Subtitle>{description}</S.Subtitle>
        </S.StepHeader>
      </S.StepContainer>
      <StepCard
        stepCard={stepCard}
        enableCustomBlock={enableCustomBlock}
        content={content}
        button={button}
        altStyling={altStyling}
        isContentHeading={isContentHeading}
        isFourColumnLayout={isFourColumnLayout}
      />
    </>
  );
};

export default StepsComponent;
